module.exports = __webpack_public_path__ + "static/media/icon_webInfo.52c5d433.svg";